import React from "react"
import MTextimage from './m_textimage'

const MTextimageQuote = (props) => {
  const newProps = {
    ...props,
    data: {
      ...props.data,
      quote: true
    }
  }

  return (
    <MTextimage {...newProps} />
  )
}

export default MTextimageQuote
